
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("1AUIX", function(module, exports) {

$parcel$export(module.exports, "updateExpandedState", () => $45f2e91b3fe13927$export$322e23ed7d99ab86);

var $e9zUf = parcelRequire("e9zUf");
const $45f2e91b3fe13927$export$322e23ed7d99ab86 = ({ isOpen: isOpen, sectionKey: sectionKey, sessionStorageKey: sessionStorageKey })=>{
    const expandedStates = (0, $e9zUf.confluenceSessionStorageInstance).getItem(sessionStorageKey);
    if (expandedStates) {
        expandedStates[sectionKey] = isOpen;
        (0, $e9zUf.confluenceSessionStorageInstance).setItem(sessionStorageKey, {
            ...expandedStates
        });
    }
};

});


//# sourceMappingURL=PersistentCollapsibleSection.a1e92b86.js.map
